import { Localization } from "../../../../../OW.Remoting/Remoting/Localization";
/**
 * HTML reprezentace tlacitka (tlacitko je jako DIV)
 */
export class Button {
    //#region Fields
    public element: HTMLDivElement;

    private _enabled: boolean = true;
    private _iconElement: HTMLSpanElement;
    private _captionElement: HTMLSpanElement = document.createElement("span");
    //#endregion Fields

    public get enabled(): boolean {
        return this._enabled;
    }

    public set enabled(v: boolean) {
        this._enabled = v;

        if (!v) this.element.setAttribute("disabled", "disabled");
        else this.element.removeAttribute("disabled");
    }

    //#region Constructors
    /**
     * @param lockey popisek
     * @param icon ikona + jeji nastaveni
     * @param type typ tlacitka
     * @param rounded ma mit tlacitko zakulacene rohy? defaultne false
     * @param element nepovinny param. Element, ze ktereho se vytvori button.
     * Pokud neni zadany, vytvori se novy element
     */
    constructor(lockey: string, icon: IIconProperties, type: ButtonType, rounded: boolean = false, element?: HTMLDivElement) {
        if (element)
            this.element = element;
        else
            this.element = document.createElement("div");
        this.element.appendChild(this._captionElement);
        this._captionElement.classList.add("btn-caption");
        this.element.classList.add("buttonElement", "btn");

        this.element.classList.add(ButtonType[type]);
        if (lockey)
            Localization.addLocData(this._captionElement, lockey);
        if (icon) {
            this._iconElement = document.createElement("span");
            this._iconElement.textContent = icon.iconText;
            if (!icon.onLeft) {
                this.element.classList.add("topIcon");
                this.element.insertBefore(this._iconElement, this.element.firstChild);
            } else
                this.element.appendChild(this._iconElement);
        }
        if (rounded)
            this.element.classList.add("rounded");
    }

    //#endregion Constructors
}

/**
 * Typy tlacitek
 */
export enum ButtonType {
    raised,
    flat,
}

export interface IIconProperties {
    /**
     * Text reprezentujici ikonu
     */
    iconText: string;
    /**
     * Pokud je true, ikona je nalevo; pokud false, tak nahore
     */
    onLeft: boolean;
}
